// extracted by mini-css-extract-plugin
export default {"root":"root__lICso","title":"title__Udxr7","paragraph":"paragraph__FHIU-"};